
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M23.869 5.335l-2.287-1.211a1.063 1.063 0 00-.996 0L18.3 5.334a.807.807 0 01-.756 0l-2.286-1.21a1.063 1.063 0 00-.996 0l-2.287 1.21a.807.807 0 01-.75.004l-2.212-1.15V20.96h11.524c.318 0 .576.259.576.577v3.603A2.862 2.862 0 0023.972 28a2.862 2.862 0 002.859-2.859V4.188l-2.212 1.15a.807.807 0 01-.75-.003zM12.42 9.155h5.845a.577.577 0 010 1.152H12.42a.577.577 0 010-1.153zm10.458 8.936H12.42a.577.577 0 010-1.153h10.458a.577.577 0 010 1.153zm0-4.036H12.42a.577.577 0 010-1.153h10.458a.577.577 0 010 1.153z","fill":"#222F5A"}}),_c('path',{attrs:{"d":"M7.859 28H21.16a4 4 0 01-1.201-2.859v-3.027H5v3.027A2.862 2.862 0 007.859 28z","fill":"#F11C33"}})])
          )
        }
      }
    